import { useEffect, useState } from 'react';
import { Page, Navbar, BlockTitle, f7, Link } from 'framework7-react';
import { Video } from '../../models/Video';
import { getDocument, storage } from '../../firebase';
import { ref, getDownloadURL } from 'firebase/storage';
import ReactPlayer from 'react-player';
import AccessRestricted from '../AccessRestricted';
import { useAuth } from '../../hooks/useAuth';

function EducationalVideoPlayer() {
  const { isAuthenticated } = useAuth();
  const [video, setVideo] = useState<Video | null>(null);

  useEffect(() => {
    const currentRoute = f7.views.main?.router.currentRoute;
    const loadVideo = async (id: string) => {
      try {
        const snap = await getDocument(`videos/${id}`);
        if (snap.exists()) {
          const data = snap.data() as Partial<Video> & { storagePath?: string };
          let url = data.url;
          if (!url && data.storagePath) {
            url = await getDownloadURL(ref(storage, data.storagePath));
          }
          setVideo({
            id: snap.id,
            title: data.title || '',
            url: url || '',
            thumbnailUrl: data.thumbnailUrl || '',
            description: data.description || '',
            featured: data.featured || false,
          });
          return;
        }
      } catch (err) {
        console.error('Error loading video', err);
      }
    };
    if (currentRoute) {
      const videoId = currentRoute.params?.videoId;
      if (videoId) loadVideo(videoId);
    }
  }, []);

  return (
    <Page name="educational-video-player" className="video-player-page">
      <Navbar className="no-outline" title="Now Playing" backLink="Back">
        <Link slot="right" back>Close</Link>
      </Navbar>
      <div className="page-content">
        {!isAuthenticated ? (
          <AccessRestricted />
        ) : video ? (
          <div>
            <div className="player-container">
              <ReactPlayer
                url={video.url}
                playing
                controls
                width="100%"
                height="100%"
                playsinline
                config={{
                  youtube: {
                    playerVars: {
                      modestbranding: 1,
                      rel: 0,
                      playsinline: 1,
                    },
                  },
                }}
                className="player"
              />
            </div>
            <div className="player-meta">
              <BlockTitle className="player-title">{video.title}</BlockTitle>
              {video.description && <p>{video.description}</p>}
            </div>
          </div>
        ) : (
          <p>Loading video...</p>
        )}
      </div>
    </Page>
  );
}

export default EducationalVideoPlayer;
// This component displays a video player for educational videos. If the user is not authenticated, it shows an access restricted message.
